import { render, staticRenderFns } from "./VideoUnderReview.vue?vue&type=template&id=d1b1b4a4&scoped=true"
import script from "./VideoUnderReview.vue?vue&type=script&lang=js"
export * from "./VideoUnderReview.vue?vue&type=script&lang=js"
import style0 from "../apply-step.css?vue&type=style&index=0&id=d1b1b4a4&prod&scoped=true&lang=css&external"
import style1 from "./VideoUnderReview.vue?vue&type=style&index=1&id=d1b1b4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b1b4a4",
  null
  
)

export default component.exports